export const singleActionTimedToastPreset = {
    name: 'mwSingleActionTimed',
    methods: [
        'textContent',
        'action',
        'theme',
        'parent'
    ],

    options: ($mdToast) => {
        'ngInject';
        return {
            template: `
                <md-toast>
                    <div class="md-toast-content">
                        <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">
                            {{ $ctrl.textContent }}
                        </span>
                        <md-button class="md-action" ng-if="$ctrl.action" ng-click="$ctrl.resolve()">
                            {{ $ctrl.action }}
                        </md-button>
                    </div>
                </md-toast>
            `,
            hideDelay: 3000,
            position: 'bottom left',
            controller: class AlertDialog {
                constructor () {
                    'ngInject';
                }

                resolve() {
                    $mdToast.hide('ok');
                };
            },
            controllerAs: '$ctrl',
            bindToController: true
        }
    }
}





// WEBPACK FOOTER //
// ./src/lib/components/toast/presets/single-action-timed.toast.preset.ts